import { Button, Card, Grid, MenuItem, Select, Switch } from "@mui/material";
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput";
import { couponTypeOptions, couponUsageOptions, regexNumber } from "helper/constant";
import React, { useEffect, useState } from "react";
import { createCoupon, getCoupon, updateCoupon } from "services/couponService";
import { getPropertiesId } from "services/propertiesService";
import { useParams } from 'react-router-dom';
import moment from "moment";
import { WBLabel } from "components/_WBcomponents/WBLabel";
import ReactQuill from "react-quill";
import { NumericFormat } from "react-number-format";
import { currencyFormat } from "helper/numberHelper";
import DeleteIcon from '@mui/icons-material/Delete';
import { addJastip } from "services/jastipService";
import { getEventList } from "services/eventService";
import DropZoneComponent from "components/_WBcomponents/DropzoneComponent";
import { isSuperAdmin } from "helper/localStorage";
import { handleUpload } from "helper/S3";
import { getCustomerList } from "services/customerService";
import CustomerDropDown from "components/_WBcomponents/CustomerDropDown";

import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import { getAdmin, getAdminList } from "services/adminService";
import { addExpense, getExpenseType } from "services/expenseService";

var toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
];

function ExpenseForm ({
    loadData
}) {

    const [ form, setForm ] = useState({
        expenseDate: null,
        expenseType: null,
        eventId: null,
        imageProof: [],
        requestBy: null,
        nominal: "",
        description: ""
    })

    const [ loading, setLoading ] = useState(false)
    const [ events, setEvents ] = useState([])
    const [ expenseType, setExpenseType ] = useState([])
    const [ closeDropDown, setCloseDropDown ] = useState(false)
    const [ onAllowFilter, setOnAllowFilter ] = useState(false)
    const [ adminList, setAdminList ] = useState([])

    useEffect(() => {
        loadEvents()
        loadAdmin()
        loadExpenseType()
    }, [])

    useEffect(() => {
        console.log(form, form.shoppingRequest)
    }, [form])

    const onChange = (e) => {
        setForm((prev) => ({
            ...prev,
            ...e
        }))
    }

    const loadEvents = async () => {
        let { data, error } = await getEventList({})
        if (error) { console.log(error) }
        if (data) { 
            setEvents(data.map(v => {
                return {
                    value: v._id,
                    label: v.eventName
                }
            }))
        }
    }

    const loadExpenseType = async () => {
        let { data, error } = await getExpenseType()
        if (error) { console.log(error) }
        if (data) { 
            setExpenseType(data.map(v => {
                return {
                    value: v._id,
                    label: v.name
                }
            }))
        }
    }

    const loadAdmin = async () => {
        let { data, error } = await getAdminList()
        if (error) { return ([]) }
        if (data) {
            if (data.length <= 0) return
            // return data.map(value => {
            //     return {
            //         label: value.name,
            //         value: value._id,
            //         data: value
            //     }
            // })
            let newData = data.map(value => {
                return {
                    label: value.name,
                    value: value._id,
                    data: value
                }
            })
            setAdminList(newData)
        }
    }

    const saveExpense = async () => {
        setLoading(true)
        try {
            // upload image to S3
            let images = []
            for (let i = 0; i < form.imageProof.length; i ++) {
                if (form.imageProof[i].name) {
                    let currImages = await handleUpload({
                        selectedFile: form.imageProof[i],
                        dirName: 'product'
                    })
                    images.push(currImages[0])
                } else {
                    images.push(form.images[i])
                }
            }
            let { data, error } = await addExpense({
                ...form,
                imageProof: images,
                eventId: form.eventId ? form.eventId.value : '',
                expenseType: form.expenseType ? form.expenseType.label : '',
                requestBy: form.requestBy ? form.requestBy.value : ''
            })
            loadData()
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const deleteAddonImages = (index) => {
        let currImages = form.imageProof
        currImages.splice(index, 1);
        onChange({ imageProof: currImages })
    }
    
    return (
        <Grid container xs={12} lg={12} p={2} pt={0} spacing={1} onClick={() => {
            setCloseDropDown(true)
        }}>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBLabel style={{
                        color: "rgb(133, 133, 133)"
                    }}>Expense Type</WBLabel>
                    <CreatableSelect onChange={(e) => {
                        onChange({ expenseType: e })
                    }} isClearable options={expenseType} />
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBSelect label={"Event"} inDialog={true} options={events} onChange={(e) => {
                        onChange({ eventId: e })
                    }} value={form.eventId}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBSelect label={"Request By"} inDialog={true} options={adminList} onChange={(e) => {
                        onChange({ requestBy: e })
                    }} value={form.requestBy}/>
                </Grid>
            </Grid>
            <Grid item xs={6} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Date"} type={"date"} inDialog={true} onChange={(e) => {
                        onChange({ expenseDate: e })
                    }} value={form.expenseDate}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBLabel style={{
                        color: "rgb(133, 133, 133)"
                    }}>Nominal</WBLabel>
                    <NumericFormat value={form.price}
                        isAllowed={(values) => {
                            const {floatValue} = values;
                            // if (form.couponType.value == "percentage") { 
                            //     if (floatValue > 100) { return false }
                            // }
                            return true
                        }}
                        onValueChange={(values) => {
                            const {formattedValue, value, floatValue} = values;
                            // do something with floatValue
                            onChange({ 
                                nominal: value.replace(/^0+/, ''),
                            })
                        }}
                        // disabled={form._id}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={WBInput}
                    />
                </Grid>
            </Grid>
            <Grid item mt={1} xs={12} md={12}>
                <WBLabel bold style={{
                    color: 'rgb(133, 133, 133)'
                }}>Upload Image</WBLabel>
                <DropZoneComponent
                    className="drop-zone"
                    uploadName='addonImage'
                    file={form.imageProof}
                    isMultiple={true}
                    onDrop={(files) => {
                        // if (files.length >= 4) { return; }
                        let currImages = form.imageProof ? form.imageProof : []
                        for (let i = 0; i < files.length; i++) {
                            currImages = currImages.concat(files[i])
                        }
                        onChange({ imageProof: currImages })
                    }}
                >
                    <div className='dropzone mb-0' style={{
                        textAlign: 'center',
                        minHeight: '150px'
                    }}>
                    <div style={{ padding: 10, alignItems: 'center' }}>
                        <label>
                            <i className='fa fa-upload mr-1' />
                            Drop itemImages to upload
                        </label>
                        <br />
                        <br />
                        <label
                            htmlFor={"addonImage"}
                            style={{ cursor: 'pointer' }}
                            className='dropzone-child mb-0'>
                            or Click to Browse
                        </label>
                        <div style={{ overflowX: 'auto' }}>
                            {
                                form.imageProof &&
                                <div style={{ textAlign: 'left' }}>
                                    Uploaded file :
                                    <div className='d-flex'>
                                    {
                                        form.imageProof.map((value, index) => {
                                            return (
                                                <div key={`${value.name}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                                    <img src={(!value.name && value.includes("https")) ? value : URL.createObjectURL(value)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                                        onClick={() => { }}
                                                    />
                                                    <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                                        {value.name}
                                                        <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                                            deleteAddonImages(index)
                                                        }}>X</span>
                                                    </label>
                                                </div>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    </div>
                </DropZoneComponent>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Remarks"} onChange={(e) => {
                        onChange({description: e.currentTarget.value})
                    }} value={form.description}/>
                </Grid>
            </Grid>
            <Grid item xs={12} mt={1} textAlign={"right"}>
                <Button variant="contained" 
                disabled={
                    !form.expenseType ||
                    !form.expenseDate ||
                    !form.requestBy ||
                    // !form.custPhoneNumber ||
                    !form.nominal ||
                    // !form.shoppingRequest || (form.shoppingRequest && form.shoppingRequest.length <= 0) ||
                    loading
                }
                onClick={() => {
                    saveExpense()
                }}>Save</Button>
            </Grid>
        </Grid>
    )
}

export default ExpenseForm